import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import DataTable from 'react-data-table-component'
import {
  exportReportUsingDateAndType,
  getQuizSubmissionsList,
} from '../../../../store/dashboard/actions'
import '../../index.scss'
import { columns, customStyles } from './index'

import Pagination from '../../../../components/UI/Pagination/Pagination'
import downarrowimg from '../../../../assets/images/chevron-down.svg'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import DateSelect from '@/components/shared/DateSelect'
import dayjs from 'dayjs'
import { Button } from '@mui/material'

const QuizAnalyticsExportSubmission = () => {
  const { t } = useTranslation('translation')

  const [filtersData, setFiltersData] = useState<{
    fromDate: string
    toDate: string
  }>({
    fromDate: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
    toDate: dayjs().format('YYYY-MM-DD'),
  })

  const [currentPage, setCurrentPage] = useState(1)
  const [perPage, setPerPage] = useState(10)
  const [paginationState, setPaginationState] = useState(null)
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Transform fromDate/toDate to API format (filter_from_date/filter_to_date)
        const apiFilters = {
          filter_from_date: filtersData.fromDate,
          filter_to_date: filtersData.toDate,
          page: currentPage,
          page_size: perPage,
        }

        const result: any = await getQuizSubmissionsList(apiFilters)
        setData(result.rows)
        setPaginationState(result.pagination)
      } catch (e: any) {
        setPaginationState([])
      }
    }
    fetchData()
  }, [filtersData.fromDate, filtersData.toDate, currentPage, perPage])

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const onExportTableClick = async () => {
    try {
      // Transform fromDate/toDate to API format for export
      const apiFilters = {
        filter_from_date: filtersData.fromDate,
        filter_to_date: filtersData.toDate,
      }

      const blob: any = await exportReportUsingDateAndType(
        'quiz-submissions-list',
        'csv',
        apiFilters,
      )

      if (!blob) {
        return
      }

      const extension =
        blob &&
        blob.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ? 'xlsx'
          : 'csv'
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `quiz-submissions-list.${extension}`)
      document.body.appendChild(link)
      link.click()
      link.parentNode.removeChild(link)
    } catch (error) {}
  }

  const ChartTableSortIcon = (data: any) => {
    return (
      <img
        src={downarrowimg}
        alt={t('collapsed')}
        className="chart-table-sort-icon"
      />
    )
  }

  return (
    <section className="tw-px-6">
      <div className="mt-3 mb-4">
        <ChildPageHeader title={t('View All Submission')} variant="compact" />

        <div className="tw-flex tw-justify-between">
          <Button variant="outlined" onClick={onExportTableClick}>
            {t('Export Table (CSV)')}
          </Button>
          <DateSelect
            onChange={({ fromDate, toDate }) => {
              setFiltersData({ fromDate, toDate })
              setCurrentPage(1)
            }}
          />
        </div>
      </div>
      <React.Fragment>
        <DataTable
          className="table-wraper-trending-questions"
          noContextMenu
          noHeader
          columns={columns()}
          data={data}
          customStyles={customStyles}
          sortIcon={<ChartTableSortIcon />}
        />

        {data && data.length > 0 && paginationState && (
          <Pagination
            currentPage={currentPage}
            pagination={paginationState}
            paginationPerPage={perPage}
            pageChange={(newPerPage: number, page: number) => {
              setPerPage(newPerPage)
              setCurrentPage(1)
            }}
            onChangePage={handlePageChange}
          />
        )}
      </React.Fragment>
    </section>
  )
}
export default QuizAnalyticsExportSubmission
